import { WorkMode } from '../SessionTree/SessionTree.types';
import { ISessionItemDetails, IIdResult } from '../../models/session.types';
import { BreadcrumbLevel } from '../DialogBreadcrumbs/DialogBreadcrumbs.types';

export interface ICommonDetailsProps {
  isSessionImported: boolean;
  removeTreeItem: () => void;
  setDeleteConfirmationPromptOpen: (confirmation: boolean) => void;
  setActiveTreeLevel: (level: BreadcrumbLevel) => void;
  isInputDisabled: () => boolean;
  workMode: WorkMode;
  setWorkMode: (mode: WorkMode) => void;
  onClose: (data: ISessionItemDetails, level: BreadcrumbLevel, onRevert: () => void) => void;
  onEdit: (data: ISessionItemDetails, onCancelEdit?: () => void) => void;
  onAddChild: (level: BreadcrumbLevel, parentId: string, examSheetId?: string) => void;
}

export interface DetailsProps extends ICommonDetailsProps {
  data: any;
  onSave: (savedObject: IIdResult, itemCreated: boolean) => void;
}

export interface CanSessionBeSetToOpen {
  sampleAssessmentGroupClosedSampleAssessmentSession: boolean;
  allDeadlinesAppliedInAssessmentSession: boolean;
  limitsAreSetUp: boolean;
  examSheetIsConfigured: boolean;
  sampleAssessmentGroupNotExistAndNoProcessesLimitIsSet: boolean;
  sampleAssessmentGroupExist: boolean;
  atLeastOneParameterIsSetUp: boolean;
  atLeastOneToleranceConditionSetUp: boolean;
  controlProcessIsOn: boolean;
  frequencyControlTasksSetUp: boolean;
  percentageControlTasksSetUp: boolean;
}
export interface CanSessionBeSetToOpenWithZwo {
  sampleAssessmentGroupClosedSampleAssessmentSession: boolean;
  allDeadlinesAppliedInAssessmentSession: boolean;
  limitsAreSetUp: boolean;
  examSheetIsConfigured: boolean;
}
export interface CanSessionBeSetToOpenNoZwo {
  allDeadlinesAppliedInAssessmentSession: boolean;
  limitsAreSetUp: boolean;
  examSheetIsConfigured: boolean;
  sampleAssessmentGroupNotExistAndNoProcessesLimitIsSet: boolean;
}

export interface isControllProcess {
  atLeastOneToleranceConditionSetUp: boolean;
  countOfProcess: boolean;
  atLeastOneParameterIsSetUp: boolean;
}

export interface CanSessionBeSetToOpenWithZwoWithControllProcess
  extends CanSessionBeSetToOpenWithZwo,
    isControllProcess {}

export interface sessionValidationMessage<T> {
  propName: keyof T;
  message: string;
}

export interface CanSessionBeSetToClosed {
  examineesComplete: boolean;
  assessmentFinished: boolean;
  tasksSolutionSheetsComplete: boolean;
  scoringComplete: boolean;
  allVerifiedWorksApprovedByPZE: boolean;
}

export const sessionValidationMessagesWithZwo: sessionValidationMessage<CanSessionBeSetToOpenWithZwo>[] = [
  {
    propName: 'sampleAssessmentGroupClosedSampleAssessmentSession',
    message: 'ZWO zakończył swoją pracę, jeśli był wymagany',
  },
  {
    propName: 'allDeadlinesAppliedInAssessmentSession',
    message: 'Wprowadzono wszystkie wymagane terminy dla wymaganych procesów w tej sesji oceniania',
  },
  {
    propName: 'limitsAreSetUp',
    message:
      'Ustawione zostały limity dla procesu oceniania (limit dzienny RGZ, limit jednocześnie otwartych RGZ, max RGZ)',
  },
  {
    propName: 'examSheetIsConfigured',
    message: 'Arkusz ma status skonfigurowany',
  },
];

export const sessionValidationMessagesNoZwo: sessionValidationMessage<CanSessionBeSetToOpenNoZwo>[] = [
  {
    propName: 'allDeadlinesAppliedInAssessmentSession',
    message: 'Wprowadzono wszystkie wymagane terminy dla wymaganych procesów w tej sesji oceniania',
  },
  {
    propName: 'limitsAreSetUp',
    message:
      'Ustawione zostały limity dla procesu oceniania (limit dzienny RGZ, limit jednocześnie otwartych RGZ, max RGZ)',
  },
  {
    propName: 'sampleAssessmentGroupNotExistAndNoProcessesLimitIsSet',
    message: 'Brak ustawionych limitów parametrów sesji Oceniania, jeżeli ZWO nie jest wymagane.',
  },
  {
    propName: 'examSheetIsConfigured',
    message: 'Arkusz ma status skonfigurowany',
  },
];

export const sessionToBeClosedValidationMessages: sessionValidationMessage<CanSessionBeSetToClosed>[] = [
  {
    propName: 'examineesComplete',
    message: 'Każdy zdający ma przypisaną kartę rozwiązań',
  },
  {
    propName: 'tasksSolutionSheetsComplete',
    message: 'Każda karta rozwiązań jest połączona ze zdającym',
  },
  {
    propName: 'scoringComplete',
    message: 'Każdy zdający ma ocenę za każde kryterium',
  },
  {
    propName: 'assessmentFinished',
    message: 'Wszystkie RGZ z procesu oceniania zostały zamknięte',
  },
  {
    propName: 'allVerifiedWorksApprovedByPZE',
    message: 'Wszystkie zweryfikowane prace zostały zatwierdzone przez PZE',
  },
];

export const isControllProcessMessage: sessionValidationMessage<isControllProcess>[] = [
  {
    propName: 'atLeastOneToleranceConditionSetUp',
    message: 'Rodzaj i zakres tolerancji',
  },
  {
    propName: 'countOfProcess',
    message: 'Częstotliwość i liczba zadań kontrolnych',
  },
  {
    propName: 'atLeastOneParameterIsSetUp',
    message: 'Limity blokujące.',
  },
];

export const mapDataResponse = (dto: any): CanSessionBeSetToClosed => ({
  examineesComplete: dto.examineesComplete,
  assessmentFinished: dto.assessmentFinished,
  tasksSolutionSheetsComplete: dto.tasksSolutionSheetsComplete,
  scoringComplete: dto.scoringComplete,
  allVerifiedWorksApprovedByPZE: !dto.hasPendingPzeApproval,
});
